import { FC } from 'react'
import { Input } from 'reactstrap'
import { FightEventFlag, FullFight } from 'web/data/models'
import { sortFightEvents } from 'web/utils/sort-utils'
import { secondsToTimestamp } from 'web/utils/time-utils'
import { groupList, isNonEmptyString } from 'web/utils/utils'

type Props = {
    fullFight: FullFight
}

export const PlaintextFightOutlineTab: FC<Props> = ({ fullFight }) => {

    const sortedEvents = [...fullFight.events].sort(sortFightEvents)
    const eventsPerSegment = groupList(sortedEvents, (event) => event.fightSegmentId)

    const value = fullFight.segments.reduce((acc, segment) => {

        const parts = [
            `#`,
            segment.userCreated ? secondsToTimestamp(segment.offset) : undefined,
            segment.name,
            isNonEmptyString(segment.condition) ? segment.condition : undefined,
            `\n`
        ].filter(removeUndefined => removeUndefined)

        acc += parts.join(` `)

        eventsPerSegment.get(segment.id).forEach(event => {
            if (event.userCreated === false) {
                return
            }

            const flagPrefix = (() => {
                if (event.flags.includes(FightEventFlag.Emphasize)) {
                    return "!"
                }
                if (event.flags.includes(FightEventFlag.Muted)) {
                    return "-"
                }

                return ''
            })()

            acc += `${flagPrefix}${secondsToTimestamp(event.offset)} ${event.name}\n`
        })

        acc += "\n"

        return acc
    }, "")

    return (
        <div>
            <p className="small">
                {[
                    "Plaintext fight outline string, useful if you want to tweak the",
                    "entire outline in a text editor instead of the application.",
                ].join(" ")}
            </p>

            <Input
                type="textarea"
                readOnly={true}
                value={value}
                style={{
                    fontFamily: "monospace",
                    fontSize: "12px",
                    minHeight: "500px"
                }}
            />
        </div>
    )
}
